export default __webpack_public_path__ + "static/media/displace2.364058f3.png";